import { gql } from '@apollo/client';

export const FETCH_DASHBOARD_WITH_PATH_URL = gql`
  query Flex_FetchDashboardWithPathUrl($userId: Int!, $path: String) {
    user(id: $userId) {
      url: redirectUrl(app: lovebird, path: $path)
    }
  }
`;
